import React, { useState, useEffect } from 'react'
import { Formik, Form, Field, FieldArray } from 'formik';
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import * as Yup from 'yup'
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import axios from 'axios';


function ImsNewFormsStage1() {
    const history = useHistory();
    const [initialValues, setInitialValues] = useState({
        id: "",
        orgCode: 0,
        companyName: "",
        noOfTempLoc: "",
        compliancestandard: "",
        dateofaudit: "",
        clearancedate: new Date(),
        auditteam: "",
        teamleader: "",
        teamleaderName: "",
        auditorOneName: "",
        auditorTwoName: "",

        justification: "",
        remarkofstage: "Yes",
        validationofprocesses: "",
        commentbyauditor: "Yes",
        productmanufacturing: "",
        materialspecification: "",
        fullyorpartially: "",
        customerrequirements: "",
        mrmconducted: "",
        attendedby: "",
        managementfrequency: "",
        managementdate: new Date(),
        statusncclosing: "",
        nonconformity: "",
        frequency: "",
        dateia: new Date(),
        controlofprocess: "",
        relateddocuments: "",
        nacecode: "",
        effectivenumber: "",
        noOfShifts: "",
        total: "",
        repetitiveprocess: "",
        processdetails: "",
        regulatoryaspects: "",
        clientStatus: "",
        clientlocation: "",
        objectivestage: "",
        scopeofcertification: "",
        requirementsiso: "Yes",
        standardiso: "Yes",
        listedscope: "Yes",
        qualitymanagement: "Yes",
        compliancerequirements: "Yes",
        effectivemangement: "Yes",
        prerequisiteprogrammes: "Yes",
        remarkgeneralone: "",
        generalone: "Yes",
        remarkgeneraltwo: "",
        generaltwo: "Yes",
        remarkgeneralthree: "",
        generalthree: "Yes",
        remarkgeneralfour: "",
        generalfour: "Yes",
        remarkgeneralfive: "",
        generalfive: "Yes",
        remarkgeneralsix: "",
        generalsix: "Yes",
        remarkgeneralseven: "",
        generalseven: "Yes",
        remarkgeneraleight: "",
        generaleight: "Yes",
        remarkgeneralnine: "",
        generalnine: "Yes",
        remarkgeneralten: "",
        generalten: "Yes",
        remarkgeneraleleven: "",
        generaleleven: "Yes",
        remarkgeneraltwelve: "",
        generaltwelve: "Yes",
        remarkgeneralthirteen: "",
        generalthirteen: "Yes",
        remarkgeneralfourteen: "",
        generalfourteen: "Yes",
        remarkgeneralfifteen: "",
        generalfifteen: "Yes",
        remarkgeneralsixteen: "",
        generalsixteen: "Yes",
        remarkgeneralseventeen: "",
        generalseventeen: "Yes",
        departmentName:""
    })

    const onSubmit = (values, { setSubmitting, resetForm }) => {

        mutation.mutate(values)
    }

    const validationSchema = Yup.object({
        objectivestage: Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        clientlocation: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        regulatoryaspects: Yup.string().required('Required').max(100, 'Maximum 100 Characters are allowed!!'),
        processdetails: Yup.string().required('Required').max(500, 'Maximum 500 Characters are allowed!!'),
        repetitiveprocess: Yup.string().required('Required').max(100, 'Maximum 100 Characters are allowed!!'),
        relateddocuments: Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        controlofprocess: Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        frequency: Yup.string().required('Required'),
        managementfrequency: Yup.string().required('Required'),
        nonconformity: Yup.string().required('Required'),
        statusncclosing: Yup.string().required('Required'),
        customerrequirements: Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        fullyorpartially: Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        materialspecification: Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        productmanufacturing: Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        justification: Yup.string().required('Required').max(1000, 'Maximum 1000 Characters are allowed!!'),
        validationofprocesses: Yup.string().required('Required').max(100, 'Maximum 100 Characters are allowed!!'),
        clientStatus: Yup.string().required('Required').max(100, 'Maximum 100 Characters are allowed!!'),
        dateia: Yup.string().required('Required')

    })
    const { data: departmentMasterList, departmentMasterListisLoading } = useQuery('listcertifcations',
        () => Fetcher('get', '/api/departmentMaster/get/listdeparmentmaster', {}))

    const { orgcode } = useParams()

    const getUrl = () => {
        const api = APIURL + '/api/rfq/get/orgdetails/' + orgcode
        axios.get(api, { headers: { "Authorization": 'Bearer ' + localStorage.getItem("token") } })
            .then(Rfqdata => {
                if (Rfqdata && initialValues.orgCode === 0 && Rfqdata.data.response.auditPlanStatus === true) {
                    var tempData = Rfqdata.data.response
                    tempData.dateia = Date.parse(tempData.dateia);
                    tempData.internalaudit = Date.parse(tempData.internalaudit);
                    tempData.mrmconducted = Date.parse(tempData.mrmconducted);
                    tempData.clearancedate = Date.parse(tempData.clearancedate);
                    tempData.managementdate = Date.parse(tempData.managementdate);
                    tempData.dateofaudit = Date.parse(tempData.dateofaudit)
                    setInitialValues(tempData)
                }
            })
            .catch(err => {
                var string = JSON.stringify(err).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);

                console.log("found", found);
                if (found !== null) {
                    console.log(err)
                    // window.location.href = "/signin"
                }
            })
    }

    useEffect(() => {
        if (orgcode !== undefined) {
            getUrl()
        }

    }, [orgcode !== undefined])

    const mutation = useMutation((params) => Fetcher('patch', '/api/rfq/patch/imsallstage1auditreport', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'IMS Stage 1 Added')
                // history.push("/" + localStorage.getItem("role") + '/Viewofimsnew90011400145001stage1auditreport/' + data.data.response.orgCode);

            } else {
                var msg = 'IMS Stage 1 - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.error('Got error from backend', error)
            ToastInstance('Error', 'IMS Stage 1' + error)
        }
    })

    const gpPvtHealthSubCenterOptions = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
    ]
    const yesNo = [
        { key: 'Select', value: '-' },
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' },
    ]

    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/rfq/get/orgdetails/' + params, {}), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                tempInitialValues.departWiseData = data.data.response.departWiseData;
                if(data.data.response.departWiseData.length != departmentMasterList.data.response.length) {
                    for(let d = 0 ; d < departmentMasterList.data.response.length ; d++){
                        var tempDeptData = data.data.response.departWiseData.find(e => e.departmentID === departmentMasterList.data.response[d]._id);
                        if(!tempDeptData) {
                            tempInitialValues.departWiseData.push({
                                            departmentID			: departmentMasterList.data.response[d]._id,
											departmentName		    : departmentMasterList.data.response[d].departmentName,
											departmentArea 			: "",
											departmentRemark 		: ""
                            })
                        }
                    }
                }
                console.log("tempInitialValues", tempInitialValues)
                tempInitialValues.nacecode = data.data.response.nacecode || "";
                tempInitialValues.effectivenumber = data.data.response.effectiveNoEmpToBeAudited || "";
                tempInitialValues.noOfShifts = data.data.response.noOfShifts || "";
                tempInitialValues.total = data.data.response.total || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.dateia = Date.parse(data.data.response.dateia) || null;
                tempInitialValues.clearancedate = Date.parse(data.data.response.clearancedate) || null;
                tempInitialValues.managementdate = Date.parse(data.data.response.managementdate) || null;
                tempInitialValues.internalaudit = Date.parse(data.data.response.internalaudit) || null;
                tempInitialValues.mrmconducted = Date.parse(data.data.response.mrmconducted) || null;
                tempInitialValues.auditteam = data.data.response.auditteam || "";
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || "";
                tempInitialValues.teamleader = data.data.response.teamleader || "";
                tempInitialValues.scopeofcertification = data.data.response.scope || "";
                tempInitialValues.requirementsiso = data.data.response.requirementsiso || "Yes";
                tempInitialValues.standardiso = data.data.response.standardiso || "Yes";
                tempInitialValues.listedscope = data.data.response.listedscope || "Yes";
                tempInitialValues.qualitymanagement = data.data.response.qualitymanagement || "Yes";
                tempInitialValues.compliancerequirements = data.data.response.compliancerequirements || "Yes";
                tempInitialValues.effectivemangement = data.data.response.effectivemangement || "Yes";
                tempInitialValues.prerequisiteprogrammes = data.data.response.prerequisiteprogrammes || "Yes";
                tempInitialValues.commentbyauditor = data.data.response.commentbyauditor || "Yes";
                tempInitialValues.remarkofstage = data.data.response.remarkofstage || "Yes";
                tempInitialValues.generalone = data.data.response.generalone || "Yes";
                tempInitialValues.generaltwo = data.data.response.generaltwo || "Yes";
                tempInitialValues.generalthree = data.data.response.generalthree || "Yes";
                tempInitialValues.generalfour = data.data.response.generalfour || "Yes";
                tempInitialValues.generalfive = data.data.response.generalfive || "Yes";
                tempInitialValues.generalsix = data.data.response.generalsix || "Yes";
                tempInitialValues.generalseven = data.data.response.generalseven || "Yes";
                tempInitialValues.generaleight = data.data.response.generaleight || "Yes";
                tempInitialValues.generalnine = data.data.response.generalnine || "Yes";
                tempInitialValues.generalten = data.data.response.generalten || "Yes";
                tempInitialValues.generaleleven = data.data.response.generaleleven || "Yes";
                tempInitialValues.generaltwelve = data.data.response.generaltwelve || "Yes";
                tempInitialValues.generalthirteen = data.data.response.generalthirteen || "Yes";
                tempInitialValues.generalfourteen = data.data.response.generalfourteen || "Yes";
                tempInitialValues.generalfifteen = data.data.response.generalfifteen || "Yes";
                tempInitialValues.generalsixteen = data.data.response.generalsixteen || "Yes";
                tempInitialValues.generalseventeen = data.data.response.generalseventeen || "Yes";

                
                
                setInitialValues(tempInitialValues)
            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })

    const { data: OrgList, isLoading: orgLoading } = useQuery(
        'listorg',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesofimsallstage1data/' + localStorage.getItem("userCode"), {}))

    if (orgLoading||departmentMasterListisLoading) return <h1>Loading</h1>
    if (orgcode && initialValues.orgCode === 0) {
        window.location.href = "/signin"
        return <h1>Loading Data</h1>

    }
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                // validationSchema={validationSchema}
                onSubmit={onSubmit}

            >
                {
                    formik => <Form>
                        <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-sm-12">

                                                        <div className="formOuterDiv">

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='selectNACECode' name='orgCode' options={OrgList.data.response} type="text" label='Client Name' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} />
                                                            </div>

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type='text' label='Address' name='address' disabled={true} />
                                                            </div>

                                                            <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type='text' label='Scope of certification' name='scopeofcertification' disabled={true} />
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type='text' label='Compliance Standard' name='typeOfCertification' disabled={true} />
                                                                <FormikControl control='date' type="text" label='Date of Audit' name='dateofaudit' disabled={true} dateFormat="dd-MM-yyyy" />
                                                            </div>
                                                            <div className="form2RowDiv">
                                                                <FormikControl control='date' type='text' label='Clearance date *' name='clearancedate' dateFormat="dd-MM-yyyy" />

                                                            </div>

                                                            <div className="hrstyle headingcolor">
                                                                <h5>Audit Team</h5>
                                                            </div>

                                                            <div className="form2RowDiv">

                                                                <FormikControl control='input' type='text' label='Team Leader/ Lead Auditor' name='teamleaderName' disabled={true} />

                                                                <FormikControl control='input' type='text' label='Technical expert' name='technicalExpertName' disabled={true} />

                                                            </div>

                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type='text' label='Auditor One' name='auditorOneName' disabled={true} />
                                                                <FormikControl control='input' type='text' label='Auditor Two' name='auditorTwoName' disabled={true} />
                                                            </div>



                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type='text' label='Number of sites' name='nosites' disabled={true} className="text-right" />
                                                                <FormikControl control='input' type="text" label='Lead Auditor/Auditor' name='teamleaderName' disabled={true} />
                                                            </div>

                                                            <div className="hrstyle headingcolor">
                                                                <h4>Audit Observation</h4>
                                                            </div>
                                                            <div className="hrstyle headingcolor">
                                                                <h5 >The first stage of the audit has taken place to confirm that the organisation has:</h5>
                                                            </div>



                                                            <div className="row" style={{ marginLeft: "0.4%" }}>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">A sufficient understanding with regard to the requirements of ISO 9001:2015 </label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='requirementsiso' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">Documented information as required by the standard ISO 9001:2015</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='standardiso' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">Suitable premises for the provision of the products/service listed in the scope</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='listedscope' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">Employed suitable expertise in preparing the Quality Management System</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='qualitymanagement' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">Identified necessary statutory and regulatory and compliance requirements.</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='compliancerequirements' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">An effective management review and internal audit system in place</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='effectivemangement' options={gpPvtHealthSubCenterOptions} />
                                                                </div>

                                                                <label htmlFor="staticEmail" className="col-sm-9 mt-4">Appropriate pre-requisite programmes for stage 2 audit in place</label>
                                                                <div className="col-sm-2 mt-4">
                                                                    <FormikControl control='radio' name='prerequisiteprogrammes' options={gpPvtHealthSubCenterOptions} />
                                                                </div>
                                                            </div>
                                                            <div className="formRowDiv mt-3">
                                                                <div className="col-lg-11">
                                                                    <div class="card mb-4">
                                                                        <div class="card-body table-responsive">
                                                                            <table className="table table-bordered">
                                                                                <thead className="table-primary">
                                                                                    <tr>
                                                                                        <th>#</th>
                                                                                        <th scope="col" width="20%">Ref. / Clause<br />
                                                                                            ISO 9001:2015,<br />
                                                                                            ISO 14001:2015,<br />
                                                                                            ISO 45001:2018
                                                                                        </th>
                                                                                        <th scope="col" className="text-center" width="35%">Description </th>
                                                                                        <th scope="col" className="text-center" width="35%">Observations/Findings </th>
                                                                                        <th scope="col" className="text-center" width="10%">YES/ NO</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td className='text-center'>1</td>
                                                                                        <td>General</td>
                                                                                        <td>Clients location & site-specific conditions </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralone' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalone' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>2</td>
                                                                                        <td>General</td>
                                                                                        <td>Organization structure  </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneraltwo' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generaltwo' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>3</td>
                                                                                        <td>General</td>
                                                                                        <td>Statutory &
                                                                                            Regulatory aspects
                                                                                            (quality, environmental & legal)
                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralthree' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalthree' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>4</td>
                                                                                        <td>General</td>
                                                                                        <td>Clients’ status and understanding regarding requirements of the standard
                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralfour' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalfour' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>5</td>
                                                                                        <td>General</td>
                                                                                        <td>Scope of certification
                                                                                            &
                                                                                            ANZ-SIC code/
                                                                                            NACE code

                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralfive' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalfive' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>6</td>
                                                                                        <td>6.1.2;8.1- EMS</td>
                                                                                        <td>Aspect Impact/
                                                                                            Operational Controls

                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralsix' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalsix' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>7</td>
                                                                                        <td>6.1.2;8.1- OHSMS</td>
                                                                                        <td>HIRA;Operational Controls
                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralseven' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalseven' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>8</td>
                                                                                        <td>6.1.3;9.1.2</td>
                                                                                        <td>Legal Requirements; Evaluation of  Compliance
                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneraleight' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generaleight' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>9</td>
                                                                                        <td>6.1.3;9.1.2- OHSMS</td>
                                                                                        <td>Compliance Obligation ; Evaluation of  Compliance
                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralnine' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalnine' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>10</td>
                                                                                        <td>6.2- QMS; EMS;OHSMS</td>
                                                                                        <td>Objectives Monitoring
                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralten' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalten' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>11</td>
                                                                                        <td>7.5 </td>
                                                                                        <td>Related documented information include
                                                                                            a) Documented information as required by standard
                                                                                            b)	Quality Policy
                                                                                            c)	Quality Objectives

                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneraleleven' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generaleleven' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>12</td>
                                                                                        <td>7.5 </td>
                                                                                        <td>Related documented information include
                                                                                            a) Documented information as required by standard
                                                                                            b)	Quality Policy
                                                                                            c)	Quality Objectives

                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneraltwelve' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generaltwelve' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>13</td>
                                                                                        <td>8.4</td>
                                                                                        <td>Control of externally provided Processes, Products & Services and control there of

                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralthirteen' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalthirteen' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>14</td>
                                                                                        <td>8.3</td>
                                                                                        <td>Verification of Design & Development

                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralfourteen' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalfourteen' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>15</td>
                                                                                        <td>8.5.1</td>
                                                                                        <td>Applicability for Validation of processes and records there of
                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralfifteen' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalfifteen' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>16</td>
                                                                                        <td>9.2</td>
                                                                                        <td>Internal audit conducted
                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralsixteen' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalsixteen' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='text-center'>17</td>
                                                                                        <td>9.3</td>
                                                                                        <td>Management Review conducted (MRM)
                                                                                        </td>
                                                                                        <td><FormikControl control='inputtable' type="text" name='remarkgeneralseventeen' /> </td>
                                                                                        <td><FormikControl control='selecttable' options={yesNo} name='generalseventeen' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div></div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <label htmlFor="staticEmail" className="col-sm-9"><strong>REMARK:</strong>The objectives of Stage 1 Audit have been achieved (tick )</label>
                                                                <div className="col-sm-2">
                                                                    <FormikControl control='radio' name='remarkofstage' options={gpPvtHealthSubCenterOptions} />
                                                                </div>
                                                            </div>
                                                            <div className="formRowDiv mt-3">
                                                                <div className="col-lg-11">
                                                                    <div class="card mb-4">
                                                                        <div class="card-body table-responsive">
                                                                            <table className="table table-bordered">
                                                                                <thead className="table-primary">
                                                                                    <tr>
                                                                                        <th>Sr. No. </th>
                                                                                        <th scope="col" width="25%">Department Audited <br />

                                                                                        </th>
                                                                                        <th scope="col" className="text-center">Details of Areas for Concern </th>
                                                                                        <th scope="col" className="text-center">Review Remarks during Stage II Audit  </th>

                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        departmentMasterList.data.response && departmentMasterList.data.response.length > 0 && departmentMasterList.data.response.map((item, index) => {
                                                                                            return (
                                                                                                <tr key={index}>
                                                                                                    <td className="text-center">{index + 1}.</td>
                                                                                                    <td>{item.departmentName}</td>
                                                                                                    <td className="text-center">
                                                                                                    </td>
                                                                                                    <td className="text-center">
                                                                                                    </td>
                                                                                                </tr>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div></div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </section>

                            <div className="card-footer">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <button type="submit" className="btn btn-primary float-right" disabled={!formik.isValid}>Submit</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Form>
                }
            </Formik>
        </div>
    )
}

export default ImsNewFormsStage1
